/*jshint esversion: 6 */

export const addState = (currentState, newState) => {
    return currentState | newState;
};

export const hasState = (currentState, requestedState) => {
  return (currentState & requestedState) == requestedState;
};

export const resetState = (requestedState) => {
    return requestedState;
};
